<ng-template #blueprint>
  <ng-content></ng-content>
</ng-template>
